import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { fetchSearchResult } from "../../../API/api";
import MultiSelect from "../../MultiSelect/MultiSelect";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import "./AFModalsStyles.css";
import { Home_PAGE_URL } from "../../../Router/routerUrl";
import { removeLineBreak, replacepercentageSymbol } from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import Button from '../../../NewComponent/Button/Button';
export function AFModal() {
  const dispatch = useDispatch();
  const {
    advanceFilterModalToggle,
    updateSearchData,
    getExpertProfilePics,
    updateSearchData2,
    searchDataLoading,
    searchDocSourceFilterUpdate,
    updateDomainData,
    isShowResultsCPR,
    UpdateGenerativeAITextWhenAPICall,
    isExternalSearchAllowed
  } = bindActionCreators(Actions, dispatch);
  const modalState = useSelector((state) => state.domain);
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const domainState = useSelector((state) => state.domain);
  const navigate= useNavigate();
  const currentRoute = useLocation();
  const onClickSubmit = () => {
    isExternalSearchAllowed(false);
      isShowResultsCPR(false)
    UpdateGenerativeAITextWhenAPICall({name:'empty'})
    const searchPayload = {
      question: searchState.inputValue,
      domains: domainState.selectedDomain,
      type: "Vizerto",
      origQuestionUuid: "",
      spellCheckFlag: false,
      searchmethod: userState.searchToggle ? "bert" : "w2v",
    };
    
    advanceFilterModalToggle({ bool: false, value: "advanceFilter" });
    if(searchState.inputValue.length > 3){
      updateSearchData2(null);
    updateSearchData([]);
    searchDataLoading(true);
    searchDocSourceFilterUpdate({ value: "all", label: "All" });
    if(currentRoute.pathname.includes("/search")){
fetchSearchResult(
        searchPayload,
        updateSearchData,
        getExpertProfilePics,
        updateSearchData2
      );
    }else{
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol( searchState.inputValue))}/true`
      );
    }
      
    }
  };
  return (
    <>
      <div>
        <Modal
          show={modalState.modalState}
          size={"sm"}
          // centered={true}
          style={{marginTop:'3%'}}
          onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        >
          <Modal.Header closeButton closeVariant="gray" >
            <Modal.Title className="titleText">
              Advanced Filters
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ paddingBottom: "0px" }}>
            <div style={{ marginTop: "5px" }}>
              <span className="subTextTitle">
                AI Search <ToggleSwitch />
              </span>
              {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
              <div className="mt-4" style={{ marginTop: "5px" }}>
                <MultiSelect value={domainState.selectedDomain} onChangeFunc={updateDomainData} isMulti={true} />
              </div>
            </div>
            <div
              className="searchsuggestionModal mt-2"
              style={{ float: "right" }}
            >
              <Button onClickFunc={onClickSubmit} text={'Submit'} type={'primary'}/>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
